import { render, staticRenderFns } from "./InputChoice.vue?vue&type=template&id=67f94316&scoped=true&"
import script from "./InputChoice.vue?vue&type=script&lang=js&"
export * from "./InputChoice.vue?vue&type=script&lang=js&"
import style0 from "./InputChoice.vue?vue&type=style&index=0&id=67f94316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f94316",
  null
  
)

export default component.exports